import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {UserEditContainerComponent} from './containers/settings/user-edit-container.component';
import {AuthGuard} from '../shared/guards/auth.guard';
import {OwnerGuard} from '../shared/guards/owner.guard';
import {UserPortfolioEditContainerComponent} from './containers/portfolio/user-portfolio-edit/user-portfolio-edit-container.component';
import {UserPortfolioOneContainerComponent} from './containers/portfolio/user-portfolio-one-container/user-portfolio-one-container.component';
import {PortfolioBaseComponent} from './containers/portfolio/portfolio-base/portfolio-base.component';


const routes: Routes = [
  {path: 'users/:userId/edit', component: UserEditContainerComponent, canActivate: [AuthGuard, OwnerGuard]},
  {path: 'users/:userId', component: UserPortfolioOneContainerComponent},
  {path: 'users/:userId/portfolio/edit', component: UserPortfolioEditContainerComponent},
  {path: 'users/:userId/portfolio', component: PortfolioBaseComponent},
];

@NgModule({
    imports: [
      RouterModule.forChild(routes),
    ],
  exports: [
    RouterModule
  ]
  }
)
export class UserRouterModule{}
